import { Grid } from '@mui/material';

const ScrollContainer = ({ children, sx, ...props }) => (
  <Grid
    sx={{
      '&::-webkit-scrollbar': { width: 7 },
      '&::-webkit-scrollbar-track': { backgroundColor: '#D9D9D9', borderRadius: 100 },
      '&::-webkit-scrollbar-thumb': { backgroundColor: '#808080', borderRadius: 100 },
      scrollbarGutter: 'stable',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Grid>
);

export default ScrollContainer;
